$(document).ready(function () {
  function updateContainerHalfGap() {
    var $container = $('.container').first()

    if ($container.length) {
      var containerLeft = $container.offset().left
      var halfGap = containerLeft

      document.documentElement.style.setProperty(
        '--container-half-gap',
        halfGap + 'px',
      )
    }
  }

  $(document).ready(function () {
    updateContainerHalfGap()
  })

  $(window).on('resize', function () {
    updateContainerHalfGap()
  })

  $('.cookie .btn').on('click', function () {
    $('.cookie').removeClass('is-active')
  })

  // Cookie block height CSS variable
  ;(function initCookieHeight() {
    const cookie = document.querySelector('.cookie')
    if (!cookie) return

    function updateHeight() {
      const height = cookie.offsetHeight
      document.documentElement.style.setProperty(
        '--cookie-height',
        `${height}px`,
      )
    }

    updateHeight()

    window.addEventListener('resize', updateHeight)
  })()

  // BURGER
  ;(function initBurgerMenu() {
    const burger = $('.btn--burger')
    const menu = $('.menu')
    const header = $('.header')
    const headerNav = $('.header-nav')

    burger.on('click', function () {
      const isOpening = !$(this).hasClass('is-active')

      $(this).toggleClass('is-active')
      $('body').toggleClass('menu-open')
      $('html').toggleClass('is-ovh')
      menu.toggleClass('is-active')

      if (isOpening) {
        // window.scrollTo({ top: 0, behavior: 'smooth' })
      }
    })

    $(document).on('click', function (e) {
      if (!menu.hasClass('is-active')) return

      const isClickInside =
        $(e.target).closest('.header, .header-nav, .btn--burger').length > 0

      if (!isClickInside) {
        closeMenu()
      }
    })

    $('.link-anchor[href^="#"]').on('click', function (e) {
      const href = $(this).attr('href')
      if (!href || href === '#') return

      const target = $(href)
      if (!target.length) return

      e.preventDefault()

      closeMenu()

      setTimeout(() => {
        const offsetTop = target.offset().top - $('.header').outerHeight()

        if (window.lenis) {
          window.lenis.scrollTo(offsetTop, { immediate: false })
        } else {
          window.scrollTo({ top: offsetTop, behavior: 'smooth' })
        }
      }, 300)
    })

    function checkHeaderScroll() {
      $('.header').toggleClass('is-active', $(window).scrollTop() > 10)
    }

    $(window).on('scroll', checkHeaderScroll)
    $(document).ready(checkHeaderScroll)

    function closeMenu() {
      burger.removeClass('is-active')
      $('body').removeClass('menu-open')
      $('html').removeClass('is-ovh')
      menu.removeClass('is-active')
    }
  })()

  // $('select').styler()

  // Yandex Maps
  // ============ HELPERS ============
  function pluralize(count, words) {
    // words = ['организация', 'организации', 'организаций']
    const cases = [2, 0, 1, 1, 1, 2]
    return words[
      count % 100 > 4 && count % 100 < 20 ? 2 : cases[Math.min(count % 10, 5)]
    ]
  }

  function highlightText(text, query) {
    if (!query) return text
    const regex = new RegExp(
      `(${query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`,
      'gi',
    )
    return text.replace(regex, '<span class="color-red">$1</span>')
  }

  // ymaps.ready(function () {
  //   // ============ ORGANIZATIONS DATA ============
  //   const organizations = [
  //     {
  //       id: 1,
  //       title: 'Центр социокультурной реабилитации Дианы Гурцкой',
  //       type: 'Психолого-педагогическая помощь',
  //       district: 'ЦАО',
  //       address: 'ул. Николоямская, д. 45, стр. 1',
  //       phone: '+7 (123) 456-78-90',
  //       coords: [55.749, 37.6528],
  //       url: 'https://www.google.com/',
  //       logo: '../images/map/logo-1.jpg',
  //     },
  //     {
  //       id: 2,
  //       title: 'Мой семейный центр «Зеленоград» ГБУ',
  //       type: 'Социальная поддержка',
  //       district: 'Зеленоградский',
  //       address: 'г. Зеленоград, корп. 1145',
  //       phone: '+7 (123) 456-78-91',
  //       coords: [55.9825, 37.1814],
  //       url: 'https://www.google.com/',
  //       logo: '../images/map/logo-1.jpg',
  //     },
  //     {
  //       id: 3,
  //       title: 'Политехнический колледж №50 им. Н.А. Злобина',
  //       type: 'Образовательные услуги',
  //       district: 'Южный',
  //       address: 'ул. Академика Янгеля, д. 10',
  //       phone: '+7 (123) 456-78-92',
  //       coords: [55.5979, 37.6097],
  //       url: 'https://www.google.com/',
  //       logo: '../images/map/logo-1.jpg',
  //     },
  //     {
  //       id: 4,
  //       title: 'Реабилитационный центр для инвалидов «Ремесла»',
  //       type: 'Реабилитация',
  //       district: 'Юго-западный',
  //       address: 'ул. Профсоюзная, д. 67',
  //       phone: '+7 (123) 456-78-93',
  //       coords: [55.6544, 37.5444],
  //       url: 'https://www.google.com/',
  //       logo: '../images/map/logo-1.jpg',
  //     },
  //     {
  //       id: 5,
  //       title: 'Центр помощи семье и детям «Гармония»',
  //       type: 'Психолого-педагогическая помощь',
  //       district: 'Северный',
  //       address: 'ул. Дубнинская, д. 32',
  //       phone: '+7 (123) 456-78-94',
  //       coords: [55.8997, 37.5467],
  //       url: 'https://www.google.com/',
  //       logo: '../images/map/logo-1.jpg',
  //     },
  //     {
  //       id: 6,
  //       title: 'Социальный приют «Надежда»',
  //       type: 'Социальная поддержка',
  //       district: 'Юго-восточный',
  //       address: 'ул. Люблинская, д. 159',
  //       phone: '+7 (123) 456-78-95',
  //       coords: [55.6758, 37.7449],
  //       url: 'https://www.google.com/',
  //       logo: '../images/map/logo-1.jpg',
  //     },
  //     {
  //       id: 7,
  //       title: 'Медико-социальный центр «Здоровье»',
  //       type: 'Медицинская помощь',
  //       district: 'ЦАО',
  //       address: 'ул. Пятницкая, д. 25',
  //       phone: '+7 (123) 456-78-96',
  //       coords: [55.7412, 37.6288],
  //       url: 'https://www.google.com/',
  //       logo: '../images/map/logo-1.jpg',
  //     },
  //     {
  //       id: 8,
  //       title: 'Центр трудовой адаптации «Перспектива»',
  //       type: 'Трудоустройство',
  //       district: 'Западный',
  //       address: 'Кутузовский проспект, д. 45',
  //       phone: '+7 (123) 456-78-97',
  //       coords: [55.7401, 37.5267],
  //       url: 'https://www.google.com/',
  //       logo: '../images/map/logo-1.jpg',
  //     },
  //     {
  //       id: 9,
  //       title: 'Детский реабилитационный центр «Солнышко»',
  //       type: 'Реабилитация',
  //       district: 'Северный',
  //       address: 'ул. Фестивальная, д. 12',
  //       phone: '+7 (123) 456-78-98',
  //       coords: [55.8547, 37.4975],
  //       url: 'https://www.google.com/',
  //       logo: '../images/map/logo-1.jpg',
  //     },
  //     {
  //       id: 10,
  //       title: 'Благотворительный фонд «Добрые руки»',
  //       type: 'Социальная поддержка',
  //       district: 'Восточный',
  //       address: 'Щёлковское шоссе, д. 77',
  //       phone: '+7 (123) 456-78-99',
  //       coords: [55.8142, 37.7986],
  //       url: 'https://www.google.com/',
  //       logo: '../images/map/logo-1.jpg',
  //     },
  //     {
  //       id: 11,
  //       title: 'Психологический центр «Гармония души»',
  //       type: 'Психолого-педагогическая помощь',
  //       district: 'Юго-западный',
  //       address: 'Ленинский проспект, д. 89',
  //       phone: '+7 (123) 456-79-00',
  //       coords: [55.6847, 37.5261],
  //       url: 'https://www.google.com/',
  //       logo: '../images/map/logo-1.jpg',
  //     },
  //     {
  //       id: 12,
  //       title: 'Центр социальной помощи «Опора»',
  //       type: 'Юридическая помощь',
  //       district: 'Южный',
  //       address: 'Варшавское шоссе, д. 125',
  //       phone: '+7 (123) 456-79-01',
  //       coords: [55.6197, 37.6197],
  //       url: 'https://www.google.com/',
  //       logo: '../images/map/logo-1.jpg',
  //     },
  //   ]

  //   // ============ PIN PATHS ============
  //   const PIN_BLACK = '../images/map/pin-black.svg'
  //   const PIN_RED = '../images/map/pin-red.svg'
  //   const PIN_SIZE = [57, 57]
  //   const PIN_OFFSET = [-28, -57]

  //   // ============ MAP INITIALIZATION ============
  //   const map = new ymaps.Map('map', {
  //     center: [55.755864, 37.617698],
  //     zoom: 10,
  //     controls: ['zoomControl'],
  //   })

  //   map.panes.get('ground').getElement().style.filter =
  //     'grayscale(100%) brightness(1.05) contrast(0.9)'

  //   // ============ CUSTOM PIN LAYOUT WITH NUMBER ============
  //   const createPinLayout = function (pinImage, textColor) {
  //     return ymaps.templateLayoutFactory.createClass(
  //       `<div class="y-pin">
  //       <img src="${pinImage}" class="y-pin__image">
  //       <span class="y-pin__number" style="color: ${textColor};">{{ properties.number }}</span>
  //     </div>`,
  //     )
  //   }

  //   const DarkPinLayout = createPinLayout(PIN_BLACK, '#393939')
  //   const RedPinLayout = createPinLayout(PIN_RED, '#ffffff')

  //   // ============ BALLOON LAYOUT ============
  //   const BalloonLayout = ymaps.templateLayoutFactory.createClass(
  //     `<div class="y-balloon">
  //   <button class="y-balloon__close" type="button"></button>
  //   <div class="y-balloon__title">{{ properties.title }}</div>
  //   <div class="y-balloon__subtitle">$[properties.subtitle]</div>
  //   <div class="y-balloon__subtitle">Телефон: $[properties.phone]</div>
  //   <div class="map-sidebar-item__button">
  //     <a href="{{ properties.url }}" class="btn btn--link-s" target="_blank">Подробнее</a>
  //   </div>
  // </div>`,
  //     {
  //       build: function () {
  //         BalloonLayout.superclass.build.call(this)
  //         const closeBtn =
  //           this.getParentElement().querySelector('.y-balloon__close')
  //         this._onCloseClick = () => this.events.fire('userclose')
  //         closeBtn.addEventListener('click', this._onCloseClick)
  //       },
  //       clear: function () {
  //         const closeBtn =
  //           this.getParentElement().querySelector('.y-balloon__close')
  //         if (closeBtn)
  //           closeBtn.removeEventListener('click', this._onCloseClick)
  //         BalloonLayout.superclass.clear.call(this)
  //       },
  //     },
  //   )

  //   // ============ CLUSTER LAYOUT ============
  //   const ClusterLayout = ymaps.templateLayoutFactory.createClass(
  //     '<div class="y-cluster">{{ properties.geoObjects.length }}</div>',
  //   )

  //   // ============ CLUSTERER ============
  //   const clusterer = new ymaps.Clusterer({
  //     clusterIcons: [
  //       {
  //         href: '',
  //         size: [80, 80],
  //         offset: [-40, -40],
  //       },
  //     ],
  //     clusterIconContentLayout: ClusterLayout,
  //     groupByCoordinates: false,
  //     clusterDisableClickZoom: false,
  //     clusterBalloonContentLayout: 'cluster#balloonCarousel',
  //   })

  //   map.geoObjects.add(clusterer)

  //   // ============ DOM ELEMENTS ============
  //   const listContainer = document.querySelector('.map-sidebar__list')
  //   const searchInput = document.querySelector(
  //     '.map-filters-item__input .inp-group__input',
  //   )
  //   const districtSelect = document.querySelectorAll(
  //     '.map-filters-item__select select',
  //   )[0]
  //   const typeSelect = document.querySelectorAll(
  //     '.map-filters-item__select select',
  //   )[1]
  //   const resetBtn = document.querySelector('.js-map-filters-reset')
  //   const countElement = document.querySelector('.map-sidebar__title')

  //   let allPlacemarks = []
  //   let activePlacemarkId = null

  //   // ============ POPULATE SELECTS FROM DATA ============
  //   function populateSelects() {
  //     const districts = [
  //       ...new Set(organizations.map((org) => org.district)),
  //     ].sort()
  //     const types = [...new Set(organizations.map((org) => org.type))].sort()

  //     if (districtSelect) {
  //       districtSelect.innerHTML =
  //         '<option value="" selected disabled>Округ или область</option>'
  //       districts.forEach((district) => {
  //         districtSelect.innerHTML += `<option value="${district}">${district}</option>`
  //       })
  //     }

  //     if (typeSelect) {
  //       typeSelect.innerHTML =
  //         '<option value="" selected disabled>Вид помощи</option>'
  //       types.forEach((type) => {
  //         typeSelect.innerHTML += `<option value="${type}">${type}</option>`
  //       })
  //     }

  //     if (typeof $ !== 'undefined' && $.fn.styler) {
  //       if (districtSelect) $(districtSelect).styler('destroy').styler()
  //       if (typeSelect) $(typeSelect).styler('destroy').styler()
  //     }
  //   }

  //   // ============ CREATE PLACEMARK ============
  //   function createPlacemark(org, index) {
  //     const number = index + 1

  //     const placemark = new ymaps.Placemark(
  //       org.coords,
  //       {
  //         title: `${number}. ${org.title}`,
  //         subtitle: `${org.type}<br>${org.district}, ${org.address}`,
  //         phone: org.phone,
  //         url: org.url,
  //         orgId: org.id,
  //         number: number,
  //       },
  //       {
  //         balloonLayout: BalloonLayout,
  //         balloonPanelMaxMapArea: 0,
  //         hideIconOnBalloonOpen: false,
  //         iconLayout: DarkPinLayout,
  //         iconShape: {
  //           type: 'Circle',
  //           coordinates: [28, 28],
  //           radius: 28,
  //         },
  //         iconOffset: PIN_OFFSET,
  //       },
  //     )

  //     // Change to red pin on balloon open
  //     placemark.events.add('balloonopen', function () {
  //       setActivePlacemark(org.id)
  //     })

  //     // Change back to dark pin on balloon close
  //     placemark.events.add('balloonclose', function () {
  //       clearActivePlacemark()
  //     })

  //     return placemark
  //   }

  //   // ============ SET ACTIVE PLACEMARK ============
  //   function setActivePlacemark(orgId) {
  //     clearActivePlacemark()

  //     activePlacemarkId = orgId
  //     const placemark = allPlacemarks.find(
  //       (p) => p.properties.get('orgId') === orgId,
  //     )

  //     if (placemark) {
  //       placemark.options.set('iconLayout', RedPinLayout)
  //     }

  //     document.querySelectorAll('.map-sidebar-item').forEach((item) => {
  //       item.classList.toggle(
  //         'is-active',
  //         parseInt(item.dataset.orgId) === orgId,
  //       )
  //     })
  //   }

  //   // ============ CLEAR ACTIVE PLACEMARK ============
  //   function clearActivePlacemark() {
  //     if (activePlacemarkId) {
  //       const placemark = allPlacemarks.find(
  //         (p) => p.properties.get('orgId') === activePlacemarkId,
  //       )
  //       if (placemark) {
  //         placemark.options.set('iconLayout', DarkPinLayout)
  //       }
  //       activePlacemarkId = null
  //     }

  //     document.querySelectorAll('.map-sidebar-item').forEach((item) => {
  //       item.classList.remove('is-active')
  //     })
  //   }

  //   // ============ RENDER LIST ============
  //   function renderList(orgs) {
  //     if (orgs.length === 0) {
  //       listContainer.classList.add('is-empty')
  //       listContainer.innerHTML = ''
  //     } else {
  //       listContainer.classList.remove('is-empty')
  //       listContainer.innerHTML = orgs
  //         .map(
  //           (org, index) => `
  //           <div class="map-sidebar-item" data-org-id="${org.id}">
  //             <div class="map-sidebar-item__content">
  //               <div class="map-sidebar-item__text">
  //                 <span class="map-sidebar-item__title">${index + 1}. ${highlightText(org.title, searchInput ? searchInput.value.trim() : '')}</span>
  //                 <ul class="map-sidebar-item__details">
  //                   <li class="map-sidebar-item__detail">${highlightText(org.type, searchInput ? searchInput.value.trim() : '')}</li>
  //                   <li class="map-sidebar-item__detail">${highlightText(org.district, searchInput ? searchInput.value.trim() : '')}, ${highlightText(org.address, searchInput ? searchInput.value.trim() : '')}</li>
  //                   <li class="map-sidebar-item__detail">Телефон: ${org.phone}</li>
  //                 </ul>
  //               </div>
  //               <img src="${org.logo}" alt="" class="map-sidebar-item__logo">
  //             </div>
  //             <div class="map-sidebar-item__button">
  //               <a href="${org.url}" class="btn btn--link-s" target="_blank">Подробнее</a>
  //             </div>
  //           </div>
  //         `,
  //         )
  //         .join('')
  //     }

  //     if (countElement) {
  //       const word = pluralize(orgs.length, [
  //         'организация',
  //         'организации',
  //         'организаций',
  //       ])
  //       countElement.textContent = `Найдено: ${orgs.length} ${word}`
  //     }

  //     bindListItemClicks()
  //   }

  //   // ============ BIND LIST ITEM CLICKS ============
  //   function bindListItemClicks() {
  //     document.querySelectorAll('.map-sidebar-item').forEach((item) => {
  //       item.addEventListener('click', function (e) {
  //         if (e.target.closest('.btn')) return

  //         const orgId = parseInt(this.dataset.orgId)
  //         const org = organizations.find((o) => o.id === orgId)
  //         const placemark = allPlacemarks.find(
  //           (p) => p.properties.get('orgId') === orgId,
  //         )

  //         if (org && placemark) {
  //           map.setCenter(org.coords, 14, { duration: 300 })
  //           placemark.balloon.open()
  //         }
  //       })
  //     })
  //   }

  //   // ============ UPDATE MAP ============
  //   function updateMap(orgs, fitBounds = false) {
  //     clusterer.removeAll()
  //     clearActivePlacemark()

  //     allPlacemarks = orgs.map((org, index) => createPlacemark(org, index))
  //     clusterer.add(allPlacemarks)

  //     if (fitBounds && orgs.length > 0) {
  //       map
  //         .setBounds(clusterer.getBounds(), {
  //           checkZoomRange: true,
  //           zoomMargin: 50,
  //         })
  //         .catch(() => {
  //           map.setCenter(orgs[0].coords, 14)
  //         })
  //     } else if (orgs.length === 0) {
  //       map.setCenter([55.755864, 37.617698], 10)
  //     }
  //   }

  //   // ============ GET FILTERED ORGANIZATIONS ============
  //   function getFilteredOrganizations() {
  //     const searchQuery = searchInput
  //       ? searchInput.value.toLowerCase().trim()
  //       : ''
  //     const selectedDistrict = districtSelect ? districtSelect.value : ''
  //     const selectedType = typeSelect ? typeSelect.value : ''

  //     return organizations.filter((org) => {
  //       const matchesSearch =
  //         !searchQuery ||
  //         org.title.toLowerCase().includes(searchQuery) ||
  //         org.address.toLowerCase().includes(searchQuery) ||
  //         org.district.toLowerCase().includes(searchQuery)

  //       const matchesDistrict =
  //         !selectedDistrict || org.district === selectedDistrict
  //       const matchesType = !selectedType || org.type === selectedType

  //       return matchesSearch && matchesDistrict && matchesType
  //     })
  //   }

  //   // ============ APPLY FILTERS ============
  //   function applyFilters() {
  //     const filtered = getFilteredOrganizations()
  //     renderList(filtered)
  //     updateMap(filtered, true)
  //   }

  //   // ============ RESET FILTERS ============
  //   function resetFilters() {
  //     if (searchInput) searchInput.value = ''

  //     if (districtSelect) {
  //       districtSelect.selectedIndex = 0
  //       if (typeof $ !== 'undefined') $(districtSelect).trigger('refresh')
  //     }

  //     if (typeSelect) {
  //       typeSelect.selectedIndex = 0
  //       if (typeof $ !== 'undefined') $(typeSelect).trigger('refresh')
  //     }

  //     renderList(organizations)
  //     updateMap(organizations, false)
  //     map.setCenter([55.755864, 37.617698], 10)
  //   }

  //   // ============ EVENT LISTENERS ============
  //   if (searchInput) {
  //     let searchTimeout
  //     searchInput.addEventListener('input', function () {
  //       clearTimeout(searchTimeout)
  //       searchTimeout = setTimeout(applyFilters, 300)
  //     })
  //   }

  //   if (districtSelect) {
  //     districtSelect.addEventListener('change', applyFilters)
  //   }

  //   if (typeSelect) {
  //     typeSelect.addEventListener('change', applyFilters)
  //   }

  //   if (typeof $ !== 'undefined') {
  //     $(document).on('change', '.map-filters-item__select select', applyFilters)
  //   }

  //   if (resetBtn) {
  //     resetBtn.addEventListener('click', function (e) {
  //       e.preventDefault()
  //       resetFilters()
  //     })
  //   }

  //   // ============ INITIALIZATION ============
  //   populateSelects()
  //   renderList(organizations)
  //   updateMap(organizations, false)
  // })
  // ymaps.ready(function () {
  //   // ============ ORGANIZATIONS DATA ============
  //   const organizations = [
  //     {
  //       id: 1,
  //       title: 'Центр социокультурной реабилитации Дианы Гурцкая',
  //       type: 'Психолого-педагогическая помощь',
  //       district: 'ЦАО',
  //       address: 'ул. Николоямская, д. 45, стр. 1',
  //       phone: '+7 (123) 456-78-90',
  //       coords: [55.749, 37.6528],
  //       url: 'https://www.google.com/',
  //       logo: '../images/map/logo-1.jpg',
  //     },
  //     {
  //       id: 2,
  //       title: 'Мой семейный центр «Зеленоград» ГБУ',
  //       type: 'Социальная поддержка',
  //       district: 'Зеленоградский',
  //       address: 'г. Зеленоград, корп. 1145',
  //       phone: '+7 (123) 456-78-91',
  //       coords: [55.9825, 37.1814],
  //       url: 'https://www.google.com/',
  //       logo: '../images/map/logo-1.jpg',
  //     },
  //     {
  //       id: 3,
  //       title: 'Политехнический колледж №50 им. Н.А. Злобина',
  //       type: 'Образовательные услуги',
  //       district: 'Южный',
  //       address: 'ул. Академика Янгеля, д. 10',
  //       phone: '+7 (123) 456-78-92',
  //       coords: [55.5979, 37.6097],
  //       url: 'https://www.google.com/',
  //       logo: '../images/map/logo-1.jpg',
  //     },
  //     {
  //       id: 4,
  //       title: 'Реабилитационный центр для инвалидов «Ремесла»',
  //       type: 'Реабилитация',
  //       district: 'Юго-западный',
  //       address: 'ул. Профсоюзная, д. 67',
  //       phone: '+7 (123) 456-78-93',
  //       coords: [55.6544, 37.5444],
  //       url: 'https://www.google.com/',
  //       logo: '../images/map/logo-1.jpg',
  //     },
  //     {
  //       id: 5,
  //       title: 'Центр помощи семье и детям «Гармония»',
  //       type: 'Психолого-педагогическая помощь',
  //       district: 'Северный',
  //       address: 'ул. Дубнинская, д. 32',
  //       phone: '+7 (123) 456-78-94',
  //       coords: [55.8997, 37.5467],
  //       url: 'https://www.google.com/',
  //       logo: '../images/map/logo-1.jpg',
  //     },
  //     {
  //       id: 6,
  //       title: 'Социальный приют «Надежда»',
  //       type: 'Социальная поддержка',
  //       district: 'Юго-восточный',
  //       address: 'ул. Люблинская, д. 159',
  //       phone: '+7 (123) 456-78-95',
  //       coords: [55.6758, 37.7449],
  //       url: 'https://www.google.com/',
  //       logo: '../images/map/logo-1.jpg',
  //     },
  //     {
  //       id: 7,
  //       title: 'Медико-социальный центр «Здоровье»',
  //       type: 'Медицинская помощь',
  //       district: 'ЦАО',
  //       address: 'ул. Пятницкая, д. 25',
  //       phone: '+7 (123) 456-78-96',
  //       coords: [55.7412, 37.6288],
  //       url: 'https://www.google.com/',
  //       logo: '../images/map/logo-1.jpg',
  //     },
  //     {
  //       id: 8,
  //       title: 'Центр трудовой адаптации «Перспектива»',
  //       type: 'Трудоустройство',
  //       district: 'Западный',
  //       address: 'Кутузовский проспект, д. 45',
  //       phone: '+7 (123) 456-78-97',
  //       coords: [55.7401, 37.5267],
  //       url: 'https://www.google.com/',
  //       logo: '../images/map/logo-1.jpg',
  //     },
  //     {
  //       id: 9,
  //       title: 'Детский реабилитационный центр «Солнышко»',
  //       type: 'Реабилитация',
  //       district: 'Северный',
  //       address: 'ул. Фестивальная, д. 12',
  //       phone: '+7 (123) 456-78-98',
  //       coords: [55.8547, 37.4975],
  //       url: 'https://www.google.com/',
  //       logo: '../images/map/logo-1.jpg',
  //     },
  //     {
  //       id: 10,
  //       title: 'Благотворительный фонд «Добрые руки»',
  //       type: 'Социальная поддержка',
  //       district: 'Восточный',
  //       address: 'Щёлковское шоссе, д. 77',
  //       phone: '+7 (123) 456-78-99',
  //       coords: [55.8142, 37.7986],
  //       url: 'https://www.google.com/',
  //       logo: '../images/map/logo-1.jpg',
  //     },
  //     {
  //       id: 11,
  //       title: 'Психологический центр «Гармония души»',
  //       type: 'Психолого-педагогическая помощь',
  //       district: 'Юго-западный',
  //       address: 'Ленинский проспект, д. 89',
  //       phone: '+7 (123) 456-79-00',
  //       coords: [55.6847, 37.5261],
  //       url: 'https://www.google.com/',
  //       logo: '../images/map/logo-1.jpg',
  //     },
  //     {
  //       id: 12,
  //       title: 'Центр социальной помощи «Опора»',
  //       type: 'Юридическая помощь',
  //       district: 'Южный',
  //       address: 'Варшавское шоссе, д. 125',
  //       phone: '+7 (123) 456-79-01',
  //       coords: [55.6197, 37.6197],
  //       url: 'https://www.google.com/',
  //       logo: '../images/map/logo-1.jpg',
  //     },
  //   ]

  //   // ============ PIN PATHS ============
  //   const PIN_BLACK = '../images/map/pin-black.svg'
  //   const PIN_RED = '../images/map/pin-red.svg'
  //   const PIN_SIZE = [57, 57]
  //   const PIN_OFFSET = [-28, -57]

  //   // ============ MAP INITIALIZATION ============
  //   const map = new ymaps.Map('map', {
  //     center: [55.755864, 37.617698],
  //     zoom: 10,
  //     controls: ['zoomControl'],
  //   })

  //   map.panes.get('ground').getElement().style.filter =
  //     'grayscale(100%) brightness(1.05) contrast(0.9)'

  //   // ============ CUSTOM PIN LAYOUT WITH NUMBER ============
  //   const createPinLayout = function (pinImage, textColor) {
  //     return ymaps.templateLayoutFactory.createClass(
  //       `<div class="y-pin">
  //       <img src="${pinImage}" class="y-pin__image">
  //       <span class="y-pin__number" style="color: ${textColor};">{{ properties.number }}</span>
  //     </div>`,
  //     )
  //   }

  //   const DarkPinLayout = createPinLayout(PIN_BLACK, '#393939')
  //   const RedPinLayout = createPinLayout(PIN_RED, '#ffffff')

  //   // ============ BALLOON LAYOUT ============
  //   const BalloonLayout = ymaps.templateLayoutFactory.createClass(
  //     `<div class="y-balloon">
  //   <button class="y-balloon__close" type="button"></button>
  //   <div class="y-balloon__title">{{ properties.title }}</div>
  //   <div class="y-balloon__subtitle">$[properties.subtitle]</div>
  //   <div class="y-balloon__subtitle">Телефон: $[properties.phone]</div>
  //   <div class="map-sidebar-item__button">
  //     <a href="{{ properties.url }}" class="btn btn--link-s" target="_blank">Подробнее</a>
  //   </div>
  // </div>`,
  //     {
  //       build: function () {
  //         BalloonLayout.superclass.build.call(this)
  //         const closeBtn =
  //           this.getParentElement().querySelector('.y-balloon__close')
  //         this._onCloseClick = () => this.events.fire('userclose')
  //         closeBtn.addEventListener('click', this._onCloseClick)
  //       },
  //       clear: function () {
  //         const closeBtn =
  //           this.getParentElement().querySelector('.y-balloon__close')
  //         if (closeBtn)
  //           closeBtn.removeEventListener('click', this._onCloseClick)
  //         BalloonLayout.superclass.clear.call(this)
  //       },
  //     },
  //   )

  //   // ============ CLUSTER LAYOUT ============
  //   const ClusterLayout = ymaps.templateLayoutFactory.createClass(
  //     '<div class="y-cluster">{{ properties.geoObjects.length }}</div>',
  //   )

  //   // ============ CLUSTERER ============
  //   const clusterer = new ymaps.Clusterer({
  //     clusterIcons: [
  //       {
  //         href: '',
  //         size: [80, 80],
  //         offset: [-40, -40],
  //       },
  //     ],
  //     clusterIconContentLayout: ClusterLayout,
  //     groupByCoordinates: false,
  //     clusterDisableClickZoom: false,
  //     clusterBalloonContentLayout: 'cluster#balloonCarousel',
  //   })

  //   map.geoObjects.add(clusterer)

  //   // ============ DOM ELEMENTS ============
  //   const listContainer = document.querySelector('.map-sidebar__list')
  //   const searchInput = document.querySelector(
  //     '.map-filters-item__input .inp-group__input',
  //   )
  //   // Селекти по порядку: перший - округ, другий - вид допомоги
  //   const $districtSelect = $('.map-filters-item__input .js-select').eq(0)
  //   const $typeSelect = $('.map-filters-item__input .js-select').eq(1)
  //   const resetBtn = document.querySelector('.js-map-filters-reset')
  //   const countElement = document.querySelector('.map-sidebar__title')

  //   let allPlacemarks = []
  //   let activePlacemarkId = null

  //   // ============ POPULATE SELECTS FROM DATA ============
  //   function populateSelects() {
  //     const districts = [
  //       ...new Set(organizations.map((org) => org.district)),
  //     ].sort()
  //     const types = [...new Set(organizations.map((org) => org.type))].sort()

  //     // Destroy existing Select2 instances first
  //     if (
  //       $districtSelect.length &&
  //       $districtSelect.hasClass('select2-hidden-accessible')
  //     ) {
  //       $districtSelect.select2('destroy')
  //     }
  //     if (
  //       $typeSelect.length &&
  //       $typeSelect.hasClass('select2-hidden-accessible')
  //     ) {
  //       $typeSelect.select2('destroy')
  //     }

  //     // Populate district select
  //     if ($districtSelect.length) {
  //       $districtSelect.empty()
  //       districts.forEach((district) => {
  //         $districtSelect.append(
  //           `<option value="${district}">${district}</option>`,
  //         )
  //       })
  //     }

  //     // Populate type select
  //     if ($typeSelect.length) {
  //       $typeSelect.empty()
  //       types.forEach((type) => {
  //         $typeSelect.append(`<option value="${type}">${type}</option>`)
  //       })
  //     }

  //     // Initialize Select2
  //     initSelect2()
  //   }

  //   // ============ INITIALIZE SELECT2 ============
  //   function initSelect2() {
  //     if ($districtSelect.length) {
  //       $districtSelect.select2({
  //         placeholder:
  //           $districtSelect.data('placeholder') || 'Округ или область',
  //         allowClear: true,
  //         closeOnSelect: false,
  //         width: '100%',
  //         language: {
  //           noResults: function () {
  //             return 'Ничего не найдено'
  //           },
  //         },
  //       })
  //     }

  //     if ($typeSelect.length) {
  //       $typeSelect.select2({
  //         placeholder: $typeSelect.data('placeholder') || 'Вид помощи',
  //         allowClear: true,
  //         closeOnSelect: false,
  //         width: '100%',
  //         language: {
  //           noResults: function () {
  //             return 'Ничего не найдено'
  //           },
  //         },
  //       })
  //     }

  //     // Bind change events after initialization
  //     $districtSelect.on('change.select2', applyFilters)
  //     $typeSelect.on('change.select2', applyFilters)
  //   }

  //   // ============ CREATE PLACEMARK ============
  //   function createPlacemark(org, index) {
  //     const number = index + 1

  //     const placemark = new ymaps.Placemark(
  //       org.coords,
  //       {
  //         title: `${number}. ${org.title}`,
  //         subtitle: `${org.type}<br>${org.district}, ${org.address}`,
  //         phone: org.phone,
  //         url: org.url,
  //         orgId: org.id,
  //         number: number,
  //       },
  //       {
  //         balloonLayout: BalloonLayout,
  //         balloonPanelMaxMapArea: 0,
  //         hideIconOnBalloonOpen: false,
  //         iconLayout: DarkPinLayout,
  //         iconShape: {
  //           type: 'Circle',
  //           coordinates: [28, 28],
  //           radius: 28,
  //         },
  //         iconOffset: PIN_OFFSET,
  //       },
  //     )

  //     placemark.events.add('balloonopen', function () {
  //       setActivePlacemark(org.id)
  //     })

  //     placemark.events.add('balloonclose', function () {
  //       clearActivePlacemark()
  //     })

  //     return placemark
  //   }

  //   // ============ SET ACTIVE PLACEMARK ============
  //   function setActivePlacemark(orgId) {
  //     clearActivePlacemark()

  //     activePlacemarkId = orgId
  //     const placemark = allPlacemarks.find(
  //       (p) => p.properties.get('orgId') === orgId,
  //     )

  //     if (placemark) {
  //       placemark.options.set('iconLayout', RedPinLayout)
  //     }

  //     document.querySelectorAll('.map-sidebar-item').forEach((item) => {
  //       item.classList.toggle(
  //         'is-active',
  //         parseInt(item.dataset.orgId) === orgId,
  //       )
  //     })
  //   }

  //   // ============ CLEAR ACTIVE PLACEMARK ============
  //   function clearActivePlacemark() {
  //     if (activePlacemarkId) {
  //       const placemark = allPlacemarks.find(
  //         (p) => p.properties.get('orgId') === activePlacemarkId,
  //       )
  //       if (placemark) {
  //         placemark.options.set('iconLayout', DarkPinLayout)
  //       }
  //       activePlacemarkId = null
  //     }

  //     document.querySelectorAll('.map-sidebar-item').forEach((item) => {
  //       item.classList.remove('is-active')
  //     })
  //   }

  //   // ============ RENDER LIST ============
  //   function renderList(orgs) {
  //     if (orgs.length === 0) {
  //       listContainer.classList.add('is-empty')
  //       listContainer.innerHTML = ''
  //     } else {
  //       listContainer.classList.remove('is-empty')
  //       listContainer.innerHTML = orgs
  //         .map(
  //           (org, index) => `
  //           <div class="map-sidebar-item" data-org-id="${org.id}">
  //             <div class="map-sidebar-item__content">
  //               <div class="map-sidebar-item__text">
  //                 <span class="map-sidebar-item__title">${index + 1}. ${highlightText(org.title, searchInput ? searchInput.value.trim() : '')}</span>
  //                 <ul class="map-sidebar-item__details">
  //                   <li class="map-sidebar-item__detail">${highlightText(org.type, searchInput ? searchInput.value.trim() : '')}</li>
  //                   <li class="map-sidebar-item__detail">${highlightText(org.district, searchInput ? searchInput.value.trim() : '')}, ${highlightText(org.address, searchInput ? searchInput.value.trim() : '')}</li>
  //                   <li class="map-sidebar-item__detail">Телефон: ${org.phone}</li>
  //                 </ul>
  //               </div>
  //               <img src="${org.logo}" alt="" class="map-sidebar-item__logo">
  //             </div>
  //             <div class="map-sidebar-item__button">
  //               <a href="${org.url}" class="btn btn--link-s" target="_blank">Подробнее</a>
  //             </div>
  //           </div>
  //         `,
  //         )
  //         .join('')
  //     }

  //     if (countElement) {
  //       const word = pluralize(orgs.length, [
  //         'организация',
  //         'организации',
  //         'организаций',
  //       ])
  //       countElement.textContent = `Найдено: ${orgs.length} ${word}`
  //     }

  //     bindListItemClicks()
  //   }

  //   // ============ BIND LIST ITEM CLICKS ============
  //   function bindListItemClicks() {
  //     document.querySelectorAll('.map-sidebar-item').forEach((item) => {
  //       item.addEventListener('click', function (e) {
  //         if (e.target.closest('.btn')) return

  //         const orgId = parseInt(this.dataset.orgId)
  //         const org = organizations.find((o) => o.id === orgId)
  //         const placemark = allPlacemarks.find(
  //           (p) => p.properties.get('orgId') === orgId,
  //         )

  //         if (org && placemark) {
  //           map.setCenter(org.coords, 14, { duration: 300 })
  //           placemark.balloon.open()
  //         }
  //       })
  //     })
  //   }

  //   // ============ UPDATE MAP ============
  //   function updateMap(orgs, fitBounds = false) {
  //     clusterer.removeAll()
  //     clearActivePlacemark()

  //     allPlacemarks = orgs.map((org, index) => createPlacemark(org, index))
  //     clusterer.add(allPlacemarks)

  //     if (fitBounds && orgs.length > 0) {
  //       map
  //         .setBounds(clusterer.getBounds(), {
  //           checkZoomRange: true,
  //           zoomMargin: 50,
  //         })
  //         .catch(() => {
  //           map.setCenter(orgs[0].coords, 14)
  //         })
  //     } else if (orgs.length === 0) {
  //       map.setCenter([55.755864, 37.617698], 10)
  //     }
  //   }

  //   // ============ GET FILTERED ORGANIZATIONS ============
  //   function getFilteredOrganizations() {
  //     const searchQuery = searchInput
  //       ? searchInput.value.toLowerCase().trim()
  //       : ''

  //     // Для multiple select .val() повертає масив або null
  //     const selectedDistricts = $districtSelect.length
  //       ? $districtSelect.val() || []
  //       : []
  //     const selectedTypes = $typeSelect.length ? $typeSelect.val() || [] : []

  //     return organizations.filter((org) => {
  //       const matchesSearch =
  //         !searchQuery ||
  //         org.title.toLowerCase().includes(searchQuery) ||
  //         org.address.toLowerCase().includes(searchQuery) ||
  //         org.district.toLowerCase().includes(searchQuery)

  //       // Якщо масив пустий - показуємо всі, інакше перевіряємо чи входить значення в масив
  //       const matchesDistrict =
  //         selectedDistricts.length === 0 ||
  //         selectedDistricts.includes(org.district)
  //       const matchesType =
  //         selectedTypes.length === 0 || selectedTypes.includes(org.type)

  //       return matchesSearch && matchesDistrict && matchesType
  //     })
  //   }

  //   // ============ APPLY FILTERS ============
  //   function applyFilters() {
  //     const filtered = getFilteredOrganizations()
  //     renderList(filtered)
  //     updateMap(filtered, true)
  //   }

  //   // ============ RESET FILTERS ============
  //   function resetFilters() {
  //     if (searchInput) {
  //       searchInput.value = ''
  //       $(searchInput).closest('.inp-group--search').removeClass('is-filled')
  //     }

  //     // Скидаємо multiple select
  //     if ($districtSelect.length) {
  //       $districtSelect.val(null).trigger('change.select2')
  //     }

  //     if ($typeSelect.length) {
  //       $typeSelect.val(null).trigger('change.select2')
  //     }

  //     renderList(organizations)
  //     updateMap(organizations, false)
  //     map.setCenter([55.755864, 37.617698], 10)
  //   }

  //   // ============ EVENT LISTENERS ============

  //   // Search input
  //   if (searchInput) {
  //     let searchTimeout
  //     searchInput.addEventListener('input', function () {
  //       clearTimeout(searchTimeout)
  //       searchTimeout = setTimeout(applyFilters, 300)
  //     })
  //   }

  //   // Reset button
  //   if (resetBtn) {
  //     resetBtn.addEventListener('click', function (e) {
  //       e.preventDefault()
  //       resetFilters()
  //     })
  //   }

  //   // Search input reset button (.inp-group__reset)
  //   $(document).on(
  //     'click',
  //     '.inp-group--search .inp-group__reset',
  //     function () {
  //       var $group = $(this).closest('.inp-group--search')
  //       $group.find('.inp-group__input').val('')
  //       $group.removeClass('is-filled')
  //       applyFilters()
  //     },
  //   )

  //   // Search input is-filled class toggle
  //   $(document).on(
  //     'input',
  //     '.inp-group--search .inp-group__input',
  //     function () {
  //       $(this)
  //         .closest('.inp-group--search')
  //         .toggleClass('is-filled', $(this).val().length > 0)
  //     },
  //   )

  //   // ============ INITIALIZATION ============
  //   populateSelects()
  //   renderList(organizations)
  //   updateMap(organizations, false)
  // })

  // ymaps.ready(function () {
  //   // ============ ORGANIZATIONS DATA ============
  //   const organizations = [
  //     {
  //       id: 1,
  //       title: 'Центр социокультурной реабилитации Дианы Гурцкой',
  //       type: 'Психолого-педагогическая помощь',
  //       district: 'ЦАО',
  //       address: 'ул. Николоямская, д. 45, стр. 1',
  //       phone: '+7 (123) 456-78-90',
  //       coords: [55.749, 37.6528],
  //       url: 'https://www.google.com/',
  //       logo: '../images/map/logo-1.jpg',
  //     },
  //     {
  //       id: 2,
  //       title: 'Мой семейный центр «Зеленоград» ГБУ',
  //       type: 'Социальная поддержка',
  //       district: 'Зеленоградский',
  //       address: 'г. Зеленоград, корп. 1145',
  //       phone: '+7 (123) 456-78-91',
  //       coords: [55.9825, 37.1814],
  //       url: 'https://www.google.com/',
  //       logo: '../images/map/logo-1.jpg',
  //     },
  //     {
  //       id: 3,
  //       title: 'Политехнический колледж №50 им. Н.А. Злобина',
  //       type: 'Образовательные услуги',
  //       district: 'Южный',
  //       address: 'ул. Академика Янгеля, д. 10',
  //       phone: '+7 (123) 456-78-92',
  //       coords: [55.5979, 37.6097],
  //       url: 'https://www.google.com/',
  //       logo: '../images/map/logo-1.jpg',
  //     },
  //     {
  //       id: 4,
  //       title: 'Реабилитационный центр для инвалидов «Ремесла»',
  //       type: 'Реабилитация',
  //       district: 'Юго-западный',
  //       address: 'ул. Профсоюзная, д. 67',
  //       phone: '+7 (123) 456-78-93',
  //       coords: [55.6544, 37.5444],
  //       url: 'https://www.google.com/',
  //       logo: '../images/map/logo-1.jpg',
  //     },
  //     {
  //       id: 5,
  //       title: 'Центр помощи семье и детям «Гармония»',
  //       type: 'Психолого-педагогическая помощь',
  //       district: 'Северный',
  //       address: 'ул. Дубнинская, д. 32',
  //       phone: '+7 (123) 456-78-94',
  //       coords: [55.8997, 37.5467],
  //       url: 'https://www.google.com/',
  //       logo: '../images/map/logo-1.jpg',
  //     },
  //     {
  //       id: 6,
  //       title: 'Социальный приют «Надежда»',
  //       type: 'Социальная поддержка',
  //       district: 'Юго-восточный',
  //       address: 'ул. Люблинская, д. 159',
  //       phone: '+7 (123) 456-78-95',
  //       coords: [55.6758, 37.7449],
  //       url: 'https://www.google.com/',
  //       logo: '../images/map/logo-1.jpg',
  //     },
  //     {
  //       id: 7,
  //       title: 'Медико-социальный центр «Здоровье»',
  //       type: 'Медицинская помощь',
  //       district: 'ЦАО',
  //       address: 'ул. Пятницкая, д. 25',
  //       phone: '+7 (123) 456-78-96',
  //       coords: [55.7412, 37.6288],
  //       url: 'https://www.google.com/',
  //       logo: '../images/map/logo-1.jpg',
  //     },
  //     {
  //       id: 8,
  //       title: 'Центр трудовой адаптации «Перспектива»',
  //       type: 'Трудоустройство',
  //       district: 'Западный',
  //       address: 'Кутузовский проспект, д. 45',
  //       phone: '+7 (123) 456-78-97',
  //       coords: [55.7401, 37.5267],
  //       url: 'https://www.google.com/',
  //       logo: '../images/map/logo-1.jpg',
  //     },
  //     {
  //       id: 9,
  //       title: 'Детский реабилитационный центр «Солнышко»',
  //       type: 'Реабилитация',
  //       district: 'Северный',
  //       address: 'ул. Фестивальная, д. 12',
  //       phone: '+7 (123) 456-78-98',
  //       coords: [55.8547, 37.4975],
  //       url: 'https://www.google.com/',
  //       logo: '../images/map/logo-1.jpg',
  //     },
  //     {
  //       id: 10,
  //       title: 'Благотворительный фонд «Добрые руки»',
  //       type: 'Социальная поддержка',
  //       district: 'Восточный',
  //       address: 'Щёлковское шоссе, д. 77',
  //       phone: '+7 (123) 456-78-99',
  //       coords: [55.8142, 37.7986],
  //       url: 'https://www.google.com/',
  //       logo: '../images/map/logo-1.jpg',
  //     },
  //     {
  //       id: 11,
  //       title: 'Психологический центр «Гармония души»',
  //       type: 'Психолого-педагогическая помощь',
  //       district: 'Юго-западный',
  //       address: 'Ленинский проспект, д. 89',
  //       phone: '+7 (123) 456-79-00',
  //       coords: [55.6847, 37.5261],
  //       url: 'https://www.google.com/',
  //       logo: '../images/map/logo-1.jpg',
  //     },
  //     {
  //       id: 12,
  //       title: 'Центр социальной помощи «Опора»',
  //       type: 'Юридическая помощь',
  //       district: 'Южный',
  //       address: 'Варшавское шоссе, д. 125',
  //       phone: '+7 (123) 456-79-01',
  //       coords: [55.6197, 37.6197],
  //       url: 'https://www.google.com/',
  //       logo: '../images/map/logo-1.jpg',
  //     },
  //   ]

  //   // ============ PIN PATHS ============
  //   const PIN_BLACK = '../images/map/pin-black.svg'
  //   const PIN_RED = '../images/map/pin-red.svg'
  //   const PIN_OFFSET = [-28, -57]

  //   // ============ MAP INITIALIZATION ============
  //   const map = new ymaps.Map('map', {
  //     center: [55.755864, 37.617698],
  //     zoom: 10,
  //     controls: ['zoomControl'],
  //   })

  //   map.panes.get('ground').getElement().style.filter =
  //     'grayscale(100%) brightness(1.05) contrast(0.9)'

  //   const createPinLayout = function (pinImage, textColor) {
  //     return ymaps.templateLayoutFactory.createClass(
  //       `<div class="y-pin">
  //       <img src="${pinImage}" class="y-pin__image">
  //       <span class="y-pin__number" style="color: ${textColor};">{{ properties.number }}</span>
  //     </div>`,
  //     )
  //   }

  //   const DarkPinLayout = createPinLayout(PIN_BLACK, '#393939')
  //   const RedPinLayout = createPinLayout(PIN_RED, '#ffffff')

  //   const BalloonLayout = ymaps.templateLayoutFactory.createClass(
  //     `<div class="y-balloon">
  //       <button class="y-balloon__close" type="button"></button>
  //       <div class="y-balloon__title">{{ properties.title }}</div>
  //       <div class="y-balloon__subtitle">$[properties.subtitle]</div>
  //       <div class="y-balloon__subtitle">Телефон: $[properties.phone]</div>
  //       <div class="map-sidebar-item__button">
  //         <a href="{{ properties.url }}" class="btn btn--link-s" target="_blank">Подробнее</a>
  //       </div>
  //     </div>`,
  //     {
  //       build: function () {
  //         BalloonLayout.superclass.build.call(this)
  //         const closeBtn =
  //           this.getParentElement().querySelector('.y-balloon__close')
  //         this._onCloseClick = () => this.events.fire('userclose')
  //         closeBtn.addEventListener('click', this._onCloseClick)
  //       },
  //       clear: function () {
  //         const closeBtn =
  //           this.getParentElement().querySelector('.y-balloon__close')
  //         if (closeBtn)
  //           closeBtn.removeEventListener('click', this._onCloseClick)
  //         BalloonLayout.superclass.clear.call(this)
  //       },
  //     },
  //   )

  //   const ClusterLayout = ymaps.templateLayoutFactory.createClass(
  //     '<div class="y-cluster">{{ properties.geoObjects.length }}</div>',
  //   )

  //   const clusterer = new ymaps.Clusterer({
  //     clusterIcons: [{ href: '', size: [80, 80], offset: [-40, -40] }],
  //     clusterIconContentLayout: ClusterLayout,
  //     groupByCoordinates: false,
  //     clusterDisableClickZoom: false,
  //     clusterBalloonContentLayout: 'cluster#balloonCarousel',
  //   })

  //   map.geoObjects.add(clusterer)

  //   // ============ DOM ELEMENTS ============
  //   const listContainer = document.querySelector('.map-sidebar__list')
  //   const searchInput = document.querySelector(
  //     '.map-filters-item__input .inp-group__input',
  //   )
  //   const searchResetBtn = document.querySelector(
  //     '.inp-group--search .inp-group__reset',
  //   )
  //   const districtSelect = $('.js-select').eq(0) // Перший селект (Район)
  //   const typeSelect = $('.js-select').eq(1) // Другий селект (Вид допомоги)
  //   const resetBtn = document.querySelector('.js-map-filters-reset')
  //   const countElement = document.querySelector('.map-sidebar__title')

  //   let allPlacemarks = []
  //   let activePlacemarkId = null

  //   // ============ HELPERS ============
  //   function highlightText(text, query) {
  //     if (!query) return text
  //     const regex = new RegExp(`(${query})`, 'gi')
  //     return text.replace(regex, '<mark>$1</mark>')
  //   }

  //   function pluralize(n, forms) {
  //     return n % 10 === 1 && n % 100 !== 11
  //       ? forms[0]
  //       : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20)
  //         ? forms[1]
  //         : forms[2]
  //   }

  //   // ============ POPULATE & INIT SELECT2 ============
  //   function initSelects() {
  //     const districts = [
  //       ...new Set(organizations.map((org) => org.district)),
  //     ].sort()
  //     const types = [...new Set(organizations.map((org) => org.type))].sort()

  //     districtSelect.empty().append('<option></option>')
  //     districts.forEach((d) => districtSelect.append(new Option(d, d)))

  //     typeSelect.empty().append('<option></option>')
  //     types.forEach((t) => typeSelect.append(new Option(t, t)))

  //     $('.js-select')
  //       .each(function () {
  //         $(this).select2({
  //           placeholder: $(this).data('placeholder'),
  //           allowClear: true,
  //           closeOnSelect: false,
  //           width: '100%',
  //           language: { noResults: () => 'Ничего не найдено' },
  //         })
  //       })
  //       .on('change', applyFilters)
  //   }

  //   // ============ CORE FUNCTIONS ============
  //   function createPlacemark(org, index) {
  //     const number = index + 1
  //     const placemark = new ymaps.Placemark(
  //       org.coords,
  //       {
  //         title: `${number}. ${org.title}`,
  //         subtitle: `${org.type}<br>${org.district}, ${org.address}`,
  //         phone: org.phone,
  //         url: org.url,
  //         orgId: org.id,
  //         number: number,
  //       },
  //       {
  //         balloonLayout: BalloonLayout,
  //         iconLayout: DarkPinLayout,
  //         iconShape: { type: 'Circle', coordinates: [28, 28], radius: 28 },
  //         iconOffset: PIN_OFFSET,
  //         hideIconOnBalloonOpen: false,
  //       },
  //     )
  //     placemark.events.add('balloonopen', () => setActivePlacemark(org.id))
  //     placemark.events.add('balloonclose', () => clearActivePlacemark())
  //     return placemark
  //   }

  //   function setActivePlacemark(orgId) {
  //     clearActivePlacemark()
  //     activePlacemarkId = orgId
  //     const placemark = allPlacemarks.find(
  //       (p) => p.properties.get('orgId') === orgId,
  //     )
  //     if (placemark) placemark.options.set('iconLayout', RedPinLayout)
  //     document.querySelectorAll('.map-sidebar-item').forEach((item) => {
  //       item.classList.toggle(
  //         'is-active',
  //         parseInt(item.dataset.orgId) === orgId,
  //       )
  //     })
  //   }

  //   function clearActivePlacemark() {
  //     if (activePlacemarkId) {
  //       const placemark = allPlacemarks.find(
  //         (p) => p.properties.get('orgId') === activePlacemarkId,
  //       )
  //       if (placemark) placemark.options.set('iconLayout', DarkPinLayout)
  //       activePlacemarkId = null
  //     }
  //     document
  //       .querySelectorAll('.map-sidebar-item')
  //       .forEach((item) => item.classList.remove('is-active'))
  //   }

  //   function renderList(orgs) {
  //     const query = searchInput.value.trim()
  //     const sidebarContainer = document.querySelector('.map-sidebar')

  //     if (orgs.length === 0) {
  //       sidebarContainer.classList.add('is-empty-results') // Для показу map-sidebar__empty через CSS
  //       listContainer.innerHTML = ''
  //     } else {
  //       sidebarContainer.classList.remove('is-empty-results')
  //       listContainer.innerHTML = orgs
  //         .map(
  //           (org, index) => `
  //           <div class="map-sidebar-item" data-org-id="${org.id}">
  //             <div class="map-sidebar-item__content">
  //               <div class="map-sidebar-item__text">
  //                 <span class="map-sidebar-item__title">${index + 1}. ${highlightText(org.title, query)}</span>
  //                 <ul class="map-sidebar-item__details">
  //                   <li class="map-sidebar-item__detail">${highlightText(org.type, query)}</li>
  //                   <li class="map-sidebar-item__detail">${highlightText(org.district, query)}, ${highlightText(org.address, query)}</li>
  //                   <li class="map-sidebar-item__detail">Телефон: ${org.phone}</li>
  //                 </ul>
  //               </div>
  //               <img src="${org.logo}" alt="" class="map-sidebar-item__logo">
  //             </div>
  //             <div class="map-sidebar-item__button">
  //               <a href="${org.url}" class="btn btn--link-s" target="_blank">Подробнее</a>
  //             </div>
  //           </div>
  //         `,
  //         )
  //         .join('')
  //     }

  //     if (countElement) {
  //       const word = pluralize(orgs.length, [
  //         'организация',
  //         'организации',
  //         'организаций',
  //       ])
  //       countElement.textContent = `Найдено: ${orgs.length} ${word}`
  //     }
  //     bindListItemClicks()
  //   }

  //   function bindListItemClicks() {
  //     document.querySelectorAll('.map-sidebar-item').forEach((item) => {
  //       item.addEventListener('click', function (e) {
  //         if (e.target.closest('.btn')) return
  //         const orgId = parseInt(this.dataset.orgId)
  //         const org = organizations.find((o) => o.id === orgId)
  //         const placemark = allPlacemarks.find(
  //           (p) => p.properties.get('orgId') === orgId,
  //         )

  //         if (org && placemark) {
  //           map.setCenter(org.coords, 14, { duration: 300 })
  //           placemark.balloon.open()
  //         }
  //       })
  //     })
  //   }

  //   function updateMap(orgs, fitBounds = false) {
  //     clusterer.removeAll()
  //     clearActivePlacemark()
  //     allPlacemarks = orgs.map((org, index) => createPlacemark(org, index))
  //     clusterer.add(allPlacemarks)

  //     if (fitBounds && orgs.length > 0) {
  //       map.setBounds(clusterer.getBounds(), {
  //         checkZoomRange: true,
  //         zoomMargin: 50,
  //       })
  //     } else if (orgs.length === 0) {
  //       map.setCenter([55.755864, 37.617698], 10)
  //     }
  //   }

  //   // ============ FILTERING LOGIC ============
  //   function applyFilters() {
  //     const searchQuery = searchInput.value.toLowerCase().trim()
  //     const selectedDistricts = districtSelect.val() || [] // Масив вибраних значень
  //     const selectedTypes = typeSelect.val() || []

  //     const filtered = organizations.filter((org) => {
  //       const matchesSearch =
  //         !searchQuery ||
  //         org.title.toLowerCase().includes(searchQuery) ||
  //         org.address.toLowerCase().includes(searchQuery)

  //       const matchesDistrict =
  //         selectedDistricts.length === 0 ||
  //         selectedDistricts.includes(org.district)
  //       const matchesType =
  //         selectedTypes.length === 0 || selectedTypes.includes(org.type)

  //       return matchesSearch && matchesDistrict && matchesType
  //     })

  //     renderList(filtered)
  //     updateMap(filtered, true)
  //   }

  //   // ============ EVENT LISTENERS ============
  //   let searchTimeout
  //   searchInput.addEventListener('input', function () {
  //     $(this)
  //       .closest('.inp-group--search')
  //       .toggleClass('is-filled', this.value.length > 0)
  //     clearTimeout(searchTimeout)
  //     searchTimeout = setTimeout(applyFilters, 300)
  //   })

  //   // Скидання через хрестик в інпуті
  //   if (searchResetBtn) {
  //     searchResetBtn.addEventListener('click', function () {
  //       const $group = $(this).closest('.inp-group--search')
  //       $group.find('.inp-group__input').val('').trigger('input') // trigger викличе applyFilters
  //       $group.removeClass('is-filled')
  //     })
  //   }

  //   // Кнопка "Очистить поиск" у порожній видачі
  //   if (resetBtn) {
  //     resetBtn.addEventListener('click', function (e) {
  //       e.preventDefault()
  //       searchInput.value = ''
  //       $(searchInput).closest('.inp-group--search').removeClass('is-filled')
  //       $('.js-select').val(null).trigger('change') // Скидає Select2 і запускає фільтрацію
  //     })
  //   }

  //   // ============ INITIALIZATION ============
  //   initSelects()
  //   renderList(organizations)
  //   updateMap(organizations, false)
  // })
  // ymaps.ready(function () {
  //   // ============ ORGANIZATIONS DATA ============
  //   const organizations = [
  //     {
  //       id: 1,
  //       title: 'Центр социокультурной реабилитации Дианы Гурцкой',
  //       type: 'Помощь 1',
  //       district: 'ЦАО',
  //       address: 'ул. Николоямская, д. 45, стр. 1',
  //       phone: '+7 (123) 456-78-90',
  //       coords: [55.749, 37.6528],
  //       url: 'https://www.google.com/',
  //       logo: '../images/map/logo-1.jpg',
  //     },
  //     {
  //       id: 2,
  //       title: 'Мой семейный центр «Зеленоград» ГБУ',
  //       type: 'Помощь 2',
  //       district: 'Зеленоградский',
  //       address: 'г. Зеленоград, корп. 1145',
  //       phone: '+7 (123) 456-78-91',
  //       coords: [55.9825, 37.1814],
  //       url: 'https://www.google.com/',
  //       logo: '../images/map/logo-1.jpg',
  //     },
  //     {
  //       id: 3,
  //       title: 'Политехнический колледж №50 им. Н.А. Злобина',
  //       type: 'Помощь 3',
  //       district: 'Южный',
  //       address: 'ул. Академика Янгеля, д. 10',
  //       phone: '+7 (123) 456-78-92',
  //       coords: [55.5979, 37.6097],
  //       url: 'https://www.google.com/',
  //       logo: '../images/map/logo-1.jpg',
  //     },
  //     {
  //       id: 4,
  //       title: 'Реабилитационный центр для инвалидов «Ремесла»',
  //       type: 'Помощь 4',
  //       district: 'Юго-западный',
  //       address: 'ул. Профсоюзная, д. 67',
  //       phone: '+7 (123) 456-78-93',
  //       coords: [55.6544, 37.5444],
  //       url: 'https://www.google.com/',
  //       logo: '../images/map/logo-1.jpg',
  //     },
  //     // ... додай інші організації, якщо потрібно
  //   ]

  //   const PIN_BLACK = '../images/map/pin-black.svg'
  //   const PIN_RED = '../images/map/pin-red.svg'
  //   const PIN_OFFSET = [-28, -57]

  //   const map = new ymaps.Map('map', {
  //     center: [55.755864, 37.617698],
  //     zoom: 10,
  //     controls: ['zoomControl'],
  //   })

  //   map.panes.get('ground').getElement().style.filter =
  //     'grayscale(100%) brightness(1.05) contrast(0.9)'

  //   const createPinLayout = (pinImage, textColor) =>
  //     ymaps.templateLayoutFactory.createClass(
  //       `<div class="y-pin"><img src="${pinImage}" class="y-pin__image"><span class="y-pin__number" style="color: ${textColor};">{{ properties.number }}</span></div>`,
  //     )

  //   const DarkPinLayout = createPinLayout(PIN_BLACK, '#393939')
  //   const RedPinLayout = createPinLayout(PIN_RED, '#ffffff')

  //   const BalloonLayout = ymaps.templateLayoutFactory.createClass(
  //     `<div class="y-balloon">
  //       <button class="y-balloon__close" type="button"></button>
  //       <div class="y-balloon__title">{{ properties.title }}</div>
  //       <div class="y-balloon__subtitle">$[properties.subtitle]</div>
  //       <div class="y-balloon__subtitle">Телефон: $[properties.phone]</div>
  //       <div class="map-sidebar-item__button"><a href="{{ properties.url }}" class="btn btn--link-s" target="_blank">Подробнее</a></div>
  //     </div>`,
  //     {
  //       build: function () {
  //         BalloonLayout.superclass.build.call(this)
  //         this._onCloseClick = () => this.events.fire('userclose')
  //         this.getParentElement()
  //           .querySelector('.y-balloon__close')
  //           .addEventListener('click', this._onCloseClick)
  //       },
  //       clear: function () {
  //         const closeBtn =
  //           this.getParentElement().querySelector('.y-balloon__close')
  //         if (closeBtn)
  //           closeBtn.removeEventListener('click', this._onCloseClick)
  //         BalloonLayout.superclass.clear.call(this)
  //       },
  //     },
  //   )

  //   const clusterer = new ymaps.Clusterer({
  //     clusterIcons: [{ href: '', size: [80, 80], offset: [-40, -40] }],
  //     clusterIconContentLayout: ymaps.templateLayoutFactory.createClass(
  //       '<div class="y-cluster">{{ properties.geoObjects.length }}</div>',
  //     ),
  //     groupByCoordinates: false,
  //     clusterDisableClickZoom: false,
  //   })
  //   map.geoObjects.add(clusterer)

  //   // ============ ELEMENTS ============
  //   const $searchInput = $('.inp-group__input')
  //   const $districtSelect = $('.js-select').eq(0)
  //   const $typeSelect = $('.js-select').eq(1)
  //   const listContainer = document.querySelector('.map-sidebar__list')
  //   const countElement = document.querySelector('.map-sidebar__title')

  //   let allPlacemarks = []
  //   let activePlacemarkId = null

  //   // ============ SELECT2 INIT ============
  //   function initSelects() {
  //     $('.js-select')
  //       .each(function () {
  //         const $this = $(this)
  //         // Вимикаємо FormStyler, якщо він намагається підхопити цей селект
  //         if ($this.parent('.jq-select').length) {
  //           $this.styler('destroy')
  //         }

  //         $this.select2({
  //           placeholder: $this.data('placeholder'),
  //           allowClear: true,
  //           closeOnSelect: false,
  //           width: '100%',
  //           language: { noResults: () => 'Ничего не найдено' },
  //         })
  //       })
  //       .on('change', applyFilters)
  //   }

  //   // ============ LOGIC ============
  //   function applyFilters() {
  //     const query = $searchInput.val().toLowerCase().trim()
  //     const districts = $districtSelect.val() || []
  //     const types = $typeSelect.val() || []

  //     const filtered = organizations.filter((org) => {
  //       const matchesSearch =
  //         !query ||
  //         org.title.toLowerCase().includes(query) ||
  //         org.address.toLowerCase().includes(query)
  //       const matchesDist =
  //         districts.length === 0 || districts.includes(org.district)
  //       const matchesType = types.length === 0 || types.includes(org.type)
  //       return matchesSearch && matchesDist && matchesType
  //     })

  //     renderList(filtered)
  //     updateMap(filtered, true)
  //   }

  //   function renderList(orgs) {
  //     const query = $searchInput.val().trim()
  //     const $sidebar = $('.map-sidebar')

  //     if (orgs.length === 0) {
  //       $sidebar.addClass('is-empty-results')
  //       listContainer.innerHTML = ''
  //     } else {
  //       $sidebar.removeClass('is-empty-results')
  //       listContainer.innerHTML = orgs
  //         .map(
  //           (org, i) => `
  //               <div class="map-sidebar-item" data-org-id="${org.id}">
  //                   <div class="map-sidebar-item__content">
  //                       <div class="map-sidebar-item__text">
  //                           <span class="map-sidebar-item__title">${i + 1}. ${org.title}</span>
  //                           <ul class="map-sidebar-item__details">
  //                               <li class="map-sidebar-item__detail">${org.type}</li>
  //                               <li class="map-sidebar-item__detail">${org.district}, ${org.address}</li>
  //                               <li class="map-sidebar-item__detail">Телефон: ${org.phone}</li>
  //                           </ul>
  //                       </div>
  //                       <img src="${org.logo}" class="map-sidebar-item__logo">
  //                   </div>
  //                   <div class="map-sidebar-item__button"><a href="${org.url}" class="btn btn--link-s" target="_blank">Подробнее</a></div>
  //               </div>
  //           `,
  //         )
  //         .join('')
  //     }

  //     if (countElement) {
  //       countElement.textContent = `Найдено: ${orgs.length} организаций`
  //     }
  //     bindClicks()
  //   }

  //   function updateMap(orgs, fit) {
  //     clusterer.removeAll()
  //     allPlacemarks = orgs.map((org, i) => {
  //       const p = new ymaps.Placemark(
  //         org.coords,
  //         {
  //           title: `${i + 1}. ${org.title}`,
  //           subtitle: `${org.type}<br>${org.district}, ${org.address}`,
  //           phone: org.phone,
  //           url: org.url,
  //           orgId: org.id,
  //           number: i + 1,
  //         },
  //         {
  //           balloonLayout: BalloonLayout,
  //           iconLayout: DarkPinLayout,
  //           iconOffset: PIN_OFFSET,
  //           hideIconOnBalloonOpen: false,
  //         },
  //       )
  //       p.events.add('balloonopen', () => setActive(org.id))
  //       p.events.add('balloonclose', () => clearActive())
  //       return p
  //     })
  //     clusterer.add(allPlacemarks)
  //     if (fit && orgs.length)
  //       map.setBounds(clusterer.getBounds(), {
  //         checkZoomRange: true,
  //         zoomMargin: 50,
  //       })
  //   }

  //   function setActive(id) {
  //     clearActive()
  //     activePlacemarkId = id
  //     const p = allPlacemarks.find((p) => p.properties.get('orgId') === id)
  //     if (p) p.options.set('iconLayout', RedPinLayout)
  //     $(`.map-sidebar-item[data-org-id="${id}"]`).addClass('is-active')
  //   }

  //   function clearActive() {
  //     if (activePlacemarkId) {
  //       const p = allPlacemarks.find(
  //         (p) => p.properties.get('orgId') === activePlacemarkId,
  //       )
  //       if (p) p.options.set('iconLayout', DarkPinLayout)
  //     }
  //     activePlacemarkId = null
  //     $('.map-sidebar-item').removeClass('is-active')
  //   }

  //   function bindClicks() {
  //     $('.map-sidebar-item')
  //       .off('click')
  //       .on('click', function (e) {
  //         if ($(e.target).closest('.btn').length) return
  //         const id = $(this).data('org-id')
  //         const p = allPlacemarks.find((p) => p.properties.get('orgId') === id)
  //         if (p) {
  //           map.setCenter(p.geometry.getCoordinates(), 14, { duration: 300 })
  //           p.balloon.open()
  //         }
  //       })
  //   }

  //   // ============ EVENTS ============
  //   $searchInput.on('input', function () {
  //     $(this)
  //       .closest('.inp-group--search')
  //       .toggleClass('is-filled', this.value.length > 0)
  //     applyFilters()
  //   })

  //   $('.inp-group__reset').on('click', function () {
  //     $searchInput.val('').trigger('input')
  //   })

  //   $('.js-map-filters-reset').on('click', function () {
  //     $searchInput.val('').trigger('input')
  //     $('.js-select').val(null).trigger('change')
  //   })

  //   // ============ START ============
  //   initSelects()
  //   renderList(organizations)
  //   updateMap(organizations, false)
  // })

  ymaps.ready(function () {
    // ============ ORGANIZATIONS DATA ============
    const organizations = [
      {
        id: 1,
        title: 'Центр социокультурной реабилитации Дианы Гурцкой',
        type: 'Психолого-педагогическая помощь',
        district: 'ЦАО',
        address: 'ул. Николоямская, д. 45, стр. 1',
        phone: '+7 (123) 456-78-90',
        coords: [55.749, 37.6528],
        url: 'https://www.google.com/',
        logo: '../images/map/logo-1.jpg',
      },
      {
        id: 2,
        title: 'Мой семейный центр «Зеленоград» ГБУ',
        type: 'Социальная поддержка',
        district: 'Зеленоградский',
        address: 'г. Зеленоград, корп. 1145',
        phone: '+7 (123) 456-78-91',
        coords: [55.9825, 37.1814],
        url: 'https://www.google.com/',
        logo: '../images/map/logo-1.jpg',
      },
      {
        id: 3,
        title: 'Политехнический колледж №50 им. Н.А. Злобина',
        type: 'Образовательные услуги',
        district: 'Южный',
        address: 'ул. Академика Янгеля, д. 10',
        phone: '+7 (123) 456-78-92',
        coords: [55.5979, 37.6097],
        url: 'https://www.google.com/',
        logo: '../images/map/logo-1.jpg',
      },
      {
        id: 4,
        title: 'Реабилитационный центр для инвалидов «Ремесла»',
        type: 'Реабилитация',
        district: 'Юго-западный',
        address: 'ул. Профсоюзная, д. 67',
        phone: '+7 (123) 456-78-93',
        coords: [55.6544, 37.5444],
        url: 'https://www.google.com/',
        logo: '../images/map/logo-1.jpg',
      },
      {
        id: 5,
        title: 'Центр помощи семье и детям «Гармония»',
        type: 'Психолого-педагогическая помощь',
        district: 'Северный',
        address: 'ул. Дубнинская, д. 32',
        phone: '+7 (123) 456-78-94',
        coords: [55.8997, 37.5467],
        url: 'https://www.google.com/',
        logo: '../images/map/logo-1.jpg',
      },
      {
        id: 6,
        title: 'Социальный приют «Надежда»',
        type: 'Социальная поддержка',
        district: 'Юго-восточный',
        address: 'ул. Люблинская, д. 159',
        phone: '+7 (123) 456-78-95',
        coords: [55.6758, 37.7449],
        url: 'https://www.google.com/',
        logo: '../images/map/logo-1.jpg',
      },
      {
        id: 7,
        title: 'Медико-социальный центр «Здоровье»',
        type: 'Медицинская помощь',
        district: 'ЦАО',
        address: 'ул. Пятницкая, д. 25',
        phone: '+7 (123) 456-78-96',
        coords: [55.7412, 37.6288],
        url: 'https://www.google.com/',
        logo: '../images/map/logo-1.jpg',
      },
    ]

    const PIN_BLACK = '../images/map/pin-black.svg'
    const PIN_RED = '../images/map/pin-red.svg'
    const PIN_OFFSET = [-28, -57]

    const map = new ymaps.Map('map', {
      center: [55.755864, 37.617698],
      zoom: 10,
      controls: ['zoomControl'],
    })

    map.panes.get('ground').getElement().style.filter =
      'grayscale(100%) brightness(1.05) contrast(0.9)'

    const createPinLayout = (pinImage, textColor) =>
      ymaps.templateLayoutFactory.createClass(
        `<div class="y-pin"><img src="${pinImage}" class="y-pin__image"><span class="y-pin__number" style="color: ${textColor};">{{ properties.number }}</span></div>`,
      )

    const DarkPinLayout = createPinLayout(PIN_BLACK, '#393939')
    const RedPinLayout = createPinLayout(PIN_RED, '#ffffff')

    const BalloonLayout = ymaps.templateLayoutFactory.createClass(
      `<div class="y-balloon">
        <button class="y-balloon__close" type="button"></button>
        <div class="y-balloon__title">{{ properties.title }}</div>
        <div class="y-balloon__subtitle">$[properties.subtitle]</div>
        <div class="y-balloon__subtitle">Телефон: $[properties.phone]</div>
        <div class="map-sidebar-item__button"><a href="{{ properties.url }}" class="btn btn--link-s" target="_blank">Подробнее</a></div>
      </div>`,
      {
        build: function () {
          BalloonLayout.superclass.build.call(this)
          this._onCloseClick = () => this.events.fire('userclose')
          this.getParentElement()
            .querySelector('.y-balloon__close')
            .addEventListener('click', this._onCloseClick)
        },
        clear: function () {
          const closeBtn =
            this.getParentElement().querySelector('.y-balloon__close')
          if (closeBtn)
            closeBtn.removeEventListener('click', this._onCloseClick)
          BalloonLayout.superclass.clear.call(this)
        },
      },
    )

    const clusterer = new ymaps.Clusterer({
      clusterIcons: [{ href: '', size: [80, 80], offset: [-40, -40] }],
      clusterIconContentLayout: ymaps.templateLayoutFactory.createClass(
        '<div class="y-cluster">{{ properties.geoObjects.length }}</div>',
      ),
      groupByCoordinates: false,
    })
    map.geoObjects.add(clusterer)

    const $searchInput = $('.inp-group__input')
    const $districtSelect = $('.js-select').eq(0)
    const $typeSelect = $('.js-select').eq(1)
    const listContainer = document.querySelector('.map-sidebar__list')
    const countElement = document.querySelector('.map-sidebar__title')

    let allPlacemarks = []
    let activePlacemarkId = null

    // ============ RESET FUNCTION ============
    function resetAllFilters() {
      $searchInput
        .val('')
        .closest('.inp-group--search')
        .removeClass('is-filled')
      $('.js-select').val([]).trigger('change')
      renderList(organizations)
      updateMap(organizations, false)
      map.setCenter([55.755864, 37.617698], 10)
      map.balloon.close()
    }

    function initSelects() {
      const districts = [
        ...new Set(organizations.map((org) => org.district)),
      ].sort()
      const types = [...new Set(organizations.map((org) => org.type))].sort()
      $districtSelect.empty().append('<option></option>')
      $typeSelect.empty().append('<option></option>')
      districts.forEach((d) => $districtSelect.append(new Option(d, d)))
      types.forEach((t) => $typeSelect.append(new Option(t, t)))

      $('.js-select')
        .each(function () {
          $(this).select2({
            placeholder: $(this).data('placeholder'),
            allowClear: true,
            closeOnSelect: false,
            width: '100%',
            language: { noResults: () => 'Ничего не найдено' },
          })
        })
        .on('change', applyFilters)
    }

    function applyFilters() {
      const query = $searchInput.val().toLowerCase().trim()
      const districts = $districtSelect.val() || []
      const types = $typeSelect.val() || []

      const filtered = organizations.filter((org) => {
        const matchesSearch =
          !query ||
          org.title.toLowerCase().includes(query) ||
          org.address.toLowerCase().includes(query)
        const matchesDist =
          districts.length === 0 || districts.includes(org.district)
        const matchesType = types.length === 0 || types.includes(org.type)
        return matchesSearch && matchesDist && matchesType
      })
      renderList(filtered)
      updateMap(filtered, true)
    }

    function renderList(orgs) {
      const query = $searchInput.val().trim()
      const $sidebar = $('.map-sidebar')
      if (orgs.length === 0) {
        $sidebar.addClass('is-empty-results')
        listContainer.innerHTML = ''
      } else {
        $sidebar.removeClass('is-empty-results')
        listContainer.innerHTML = orgs
          .map(
            (org, i) => `
                <div class="map-sidebar-item" data-org-id="${org.id}">
                    <div class="map-sidebar-item__content">
                        <div class="map-sidebar-item__text">
                            <span class="map-sidebar-item__title">${i + 1}. ${org.title}</span>
                            <ul class="map-sidebar-item__details">
                                <li class="map-sidebar-item__detail">${org.type}</li>
                                <li class="map-sidebar-item__detail">${org.district}, ${org.address}</li>
                                <li class="map-sidebar-item__detail">Телефон: ${org.phone}</li>
                            </ul>
                        </div>
                        <img src="${org.logo}" class="map-sidebar-item__logo">
                    </div>
                    <div class="map-sidebar-item__button"><a href="${org.url}" class="btn btn--link-s" target="_blank">Подробнее</a></div>
                </div>`,
          )
          .join('')
      }
      if (countElement) {
        const word =
          orgs.length === 1
            ? 'организация'
            : orgs.length > 1 && orgs.length < 5
              ? 'организации'
              : 'организаций'
        countElement.textContent = `Найдено: ${orgs.length} ${word}`
      }
      bindClicks()
    }

    function updateMap(orgs, fit) {
      clusterer.removeAll()
      allPlacemarks = orgs.map((org, i) => {
        const p = new ymaps.Placemark(
          org.coords,
          {
            title: `${i + 1}. ${org.title}`,
            subtitle: `${org.type}<br>${org.district}, ${org.address}`,
            phone: org.phone,
            url: org.url,
            orgId: org.id,
            number: i + 1,
          },
          {
            balloonLayout: BalloonLayout,
            iconLayout: DarkPinLayout,
            iconOffset: PIN_OFFSET,
            hideIconOnBalloonOpen: false,
            hasBalloon: true,
            iconShape: {
              type: 'Circle',
              coordinates: [28, 28],
              radius: 28,
            },
          },
        )

        p.events.add('click', function (e) {
          e.stopPropagation()
          p.balloon.open()
        })

        p.events.add('balloonopen', () => setActive(org.id))
        p.events.add('balloonclose', () => clearActive())
        return p
      })
      clusterer.add(allPlacemarks)
      if (fit && orgs.length)
        map.setBounds(clusterer.getBounds(), {
          checkZoomRange: true,
          zoomMargin: 50,
        })
    }

    function setActive(id) {
      clearActive()
      activePlacemarkId = id
      const p = allPlacemarks.find((p) => p.properties.get('orgId') === id)
      if (p) p.options.set('iconLayout', RedPinLayout)
      $(`.map-sidebar-item[data-org-id="${id}"]`).addClass('is-active')
    }

    function clearActive() {
      if (activePlacemarkId) {
        const p = allPlacemarks.find(
          (p) => p.properties.get('orgId') === activePlacemarkId,
        )
        if (p) p.options.set('iconLayout', DarkPinLayout)
      }
      activePlacemarkId = null
      $('.map-sidebar-item').removeClass('is-active')
    }

    function bindClicks() {
      $('.map-sidebar-item')
        .off('click')
        .on('click', function (e) {
          if ($(e.target).closest('.btn').length) return
          const id = $(this).data('org-id')
          const p = allPlacemarks.find((p) => p.properties.get('orgId') === id)
          if (p) {
            map.setCenter(p.geometry.getCoordinates(), 14, { duration: 300 })
            p.balloon.open()
          }
        })
    }

    // ============ GLOBAL EVENTS ============
    $searchInput.on('input', function () {
      $(this)
        .closest('.inp-group--search')
        .toggleClass('is-filled', this.value.length > 0)
      applyFilters()
    })

    $('.inp-group__reset').on('click', function () {
      $searchInput.val('').trigger('input')
    })

    $('.js-map-filters-reset').on('click', function (e) {
      e.preventDefault()
      resetAllFilters()
    })

    // ============ START ============
    initSelects()
    renderList(organizations)
    updateMap(organizations, false)
  })
})

// $('.js-select').select2({
//   placeholder: $(this).data('placeholder'),
//   allowClear: true,
//   closeOnSelect: false,
//   width: '100%',
//   language: {
//     noResults: function () {
//       return 'Ничего не найдено'
//     },
//   },
// })

// $('.inp-group--search .inp-group__input').on('input', function () {
//   $(this)
//     .closest('.inp-group--search')
//     .toggleClass('is-filled', $(this).val().length > 0)
// })

// $('.inp-group--search .inp-group__reset').on('click', function () {
//   var $group = $(this).closest('.inp-group--search')
//   $group.find('.inp-group__input').val('')
//   $group.removeClass('is-filled')
// })

$(window).on('load resize', function () {
  if ($(window).width() <= 768) {
    $('[data-cut="1"], [data-cut="2"]').remove()

    $('[data-append="1"]').replaceWith(`
      <div class="tablet-s-visible footer-bottom__link-centered">
        <a href="#" class="footer-bottom__link">Политика обработки персональных данных</a>
      </div>
    `)

    $('[data-append="2"]').replaceWith(`
      <div class="tablet-s-visible">
        <a href="#" class="footer-bottom__link">Политика конфиденциальности</a>
      </div>
    `)
  }
})
